import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { getUpcFromCatalogBib } from 'app/helpers/bib/bibHelpers';
import { selectBibEntities, selectCatalogBibEntities } from 'app/selectors/EntitiesSelector';
import { selectCurrentLibrary } from 'app/selectors/LibrarySelector';
import syndeticsUnbound from 'app/utils/syndenticsUnbound';
import ReadingLevel from './ReadingLevel';

const ReadingLevelContainer = ({ metadataId }) => {
  const bibs = useSelector(selectBibEntities);
  const catalogBibs = useSelector(selectCatalogBibEntities);
  const currentLibrary = useSelector(selectCurrentLibrary);
  const [hasContent, setHasContent] = useState(false);

  const isbn = bibs.getIn([metadataId, 'briefInfo', 'isbns', 0]);
  const upc = getUpcFromCatalogBib(catalogBibs.get(metadataId));

  const isSyndeticsUnboundEnabled = currentLibrary.getIn(['syndeticsUnbound', 'isEnabled']) ?? false;
  const syndeticsUnboundAccountId =
    (isSyndeticsUnboundEnabled ? currentLibrary.getIn(['syndeticsUnbound', 'accountId']) : null) ?? null;
  const syndeticsUnboundInstanceId =
    (isSyndeticsUnboundEnabled ? currentLibrary.getIn(['syndeticsUnbound', 'instanceId']) : null) ?? null;

  useEffect(() => {
    if (!syndeticsUnboundAccountId) {
      return;
    }

    syndeticsUnbound
      .initialize(syndeticsUnboundAccountId, syndeticsUnboundInstanceId)
      .then(connectorApi => {
        const { isEnrichmentShown, populate } = connectorApi;

        populate({ isbn, upc });

        setTimeout(() => {
          setHasContent(isEnrichmentShown(syndeticsUnbound.SUPPORTED_ENRICHMENT_IDS.READING_LEVEL));
        }, 500);
      })
      .catch(() => null);
  }, [isbn, syndeticsUnboundAccountId, syndeticsUnboundInstanceId, setHasContent, upc]);

  return <ReadingLevel isVisible={hasContent} />;
};

ReadingLevelContainer.propTypes = {
  metadataId: PropTypes.string.isRequired
};

export default ReadingLevelContainer;
